module.exports = __webpack_public_path__ + "assets/easy-icon.777cc255.svg";